import React, { FC } from 'react';
import AdminMapFilter from './AdminMapFilter';
import AdminDashboardFilter from './AdminDashboardFilter';

interface IAdminFilters {
  isMap: boolean;
  setFilterState: (
    value: React.SetStateAction<{
      submitted: boolean;
      showFilter: boolean;
    }>
  ) => void;
  filterState: {
    submitted: boolean;
    showFilter: boolean;
  };
}

const AdminFilters = React.forwardRef(
  ({ filterState, setFilterState, isMap }: IAdminFilters, ref) =>
    (isMap ? (
      <AdminMapFilter
        setFilterState={setFilterState}
        ref={ref}
        filterState={filterState}
      />
    ) : (
      <AdminDashboardFilter
        setFilterState={setFilterState}
        ref={ref}
        filterState={filterState}
      />
    )),
);

export default AdminFilters;
